import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { deleteMeal } from '../../../api/diary-service';
import refetchDiaryAndEnergy from '../../../services/refetch-queries';

const useDeleteMeal = (currentDay) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: deleteMeal,
        onError: (error) => console.error('Failed to delete meal:', error)
    });

    const deleteMealAndSync = async (mealId) => {
        setIsDeleting(true);

        try {
            await mutation.mutateAsync(mealId);

            await refetchDiaryAndEnergy(queryClient, currentDay);

            await queryClient.invalidateQueries({
                queryKey: ['mealDates'],
                exact: false
            });
        } catch (error) {
            console.error('Delete and sync failed:', error);
        } finally {
            setIsDeleting(false);
        }
    };

    return {
        deleteMeal: deleteMealAndSync,
        isDeleting,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error
    };
};

export default useDeleteMeal;
